import SignaturePadWrapper from "./SignaturePad.style";
import SignatureCanvas from "react-signature-canvas";
import { Input, Button, Upload } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";

const SignaturePadContent = ({
    isShowModal,
    setIsShowModal,
    name,
    setName,
    viewedSignature,
    handleChangeName,
    errMessage,
    setErrMessage,
    sigCanvas,
    isDesktop,
    isTablet,
    save,
    handleCancel,
    removeSignature,
    uploadSignature,
    uploadProps,
    uploadButton

}) => {
  const getModalFooter = () => {
    if(viewedSignature){
      return [
        <Button className="cancel-button" onClick={handleCancel}>
          <IntlMessages id="signature.modal.cancel" />
        </Button>,
        <Button className="cancel-button remove-signature-btn" onClick={()=>removeSignature(viewedSignature.imageId)}>
        <IntlMessages id="signature.modal.remove" />
      </Button>,
        ]
    }
    return [
      <Button className="cancel-button" onClick={handleCancel}>
        <IntlMessages id="signature.modal.cancel" />
      </Button>,
      <></>,
      <Button
        className="btn-success"
        type="primary"
        onClick={() => sigCanvas.current.clear()}
      >
        <IntlMessages id="signature.modal.clearSignature" />
      </Button>,
      uploadSignature ? <Button
        className="btn-success"
        type="primary"
        onClick={uploadSignature}
      >
        <IntlMessages id="signature.modal.uploadSignature" />
      </Button> : <></>,
      <Button className="btn-success" type="primary" onClick={save}>
        <IntlMessages id="signature.modal.save" />
      </Button>,
      <div style={{ display: "none" }}>
        <Upload {...uploadProps}>
          <Button ref={uploadButton}>Upload</Button>
        </Upload>
      </div>,
    ];
  }

    return (
        <SignaturePadWrapper
        onCancel={handleCancel}
        visible={isShowModal}
        maskClosable={false}
        title="Add Signature"
        footer={getModalFooter()}
      >
        <div className="modalContainer" id="signature-path">
          <div className="form-body">
            <div className="name-group">
              <label>Name*</label>
              <Input
                size="large"
                placeholder="Input your name"
                value={name}
                readOnly={viewedSignature ? true : false}
                onChange={(e) => {
                  handleChangeName(e.target.value);
                }}
              />
              {errMessage && (
                <span style={{ color: "#ff4d4f" }}>{errMessage}</span>
              )}
            </div>
            <div className="sigPadContainer">
              <label id="signature-label">Signature*</label>
              <div id="canvas-area">
                {viewedSignature ? (
                  <img className="preview-signature"
                    src={viewedSignature.full_path}
                  ></img>
                ) : (
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      width: isDesktop ? 520 : isTablet ? 500 : 350,
                      height: 200,
                      className: "sigCanvas",
                      border: "1px solid black",
                    }}
                    ref={sigCanvas}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </SignaturePadWrapper> 
    )
};

export default SignaturePadContent;
